/* Pages Luveon (copie de luveon.com) : variante du formulaire natif, dates de livraison du jour, Kaching. Généré par build_lv.py. */
(function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function fmt(d, m, y) { var a = m === 'us' ? pad(d.getMonth() + 1) + '/' + pad(d.getDate()) : pad(d.getDate()) + '/' + pad(d.getMonth() + 1); return y ? a + '/' + d.getFullYear() : a; }
  function add(d, n) { var x = new Date(d.getTime()); x.setDate(x.getDate() + n); return x; }
  document.querySelectorAll('[data-lvm-estimate]').forEach(function (el) {
    var m = el.getAttribute('data-lvm-fmt'), t = new Date();
    var r = [fmt(t, m), fmt(t, m) + ' - ' + fmt(add(t, 2), m), fmt(add(t, 4), m) + ' - ' + fmt(add(t, 6), m)];
    el.querySelectorAll('[data-lvm-range]').forEach(function (s) { s.textContent = r[+s.getAttribute('data-lvm-range')]; });
    var ds = el.querySelector('[data-lvm-dates]'); if (ds) ds.textContent = fmt(add(t, 4), m, 1) + ' - ' + fmt(add(t, 6), m, 1);
  });
  document.querySelectorAll('[data-lvm]').forEach(function (root) {
    var native = root.querySelector('[data-lvm-native]');
    function kaching() { return !!root.querySelector('.kaching-bundles__bar'); }
    if (native && kaching()) native.hidden = true;
    if (native && window.MutationObserver) new MutationObserver(function () { if (kaching()) native.hidden = true; }).observe(root, { childList: true, subtree: true });
    var vj = root.querySelector('[data-lvm-variants]'); if (!vj || !native) return;
    var variants = JSON.parse(vj.textContent), input = root.querySelector('[data-lvm-variant]'), btn = root.querySelector('[data-lvm-add]');
    native.addEventListener('change', function () {
      var sel = Array.prototype.map.call(native.querySelectorAll('select'), function (s) { return s.value; });
      var v = variants.find(function (x) { return sel.every(function (o, i) { return x.options[i] === o; }); });
      if (!v) return;
      input.value = v.id; btn.disabled = !v.available;
      btn.querySelector('span').textContent = v.available ? btn.getAttribute('data-lvm-label') : btn.getAttribute('data-lvm-soldout');
    });
  });
})();
